import { NgModule } from '@angular/core';
import { NavMenuComponent } from './nav-menu.component';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ContactListComponent } from '../contacts/contact-list/contact-list.component';
import { ContactListContactsComponent } from '../contacts/contact-list/contact-list-contacts/contact-list-contacts.component';
import { CustomFieldComponent } from '../basics/custom-field/custom-field.component';
import { ContactComponent } from '../contacts/contact/contact.component';
import { CampaignComponent } from '../campaigns/campaign/campaign.component';
import { ContactSearchComponent } from '../contacts/contact-search/contact-search.component';
import { ImportFilesComponent } from '../contacts/import-files/import-files.component';
import { DisplaySuccessImportComponent } from '../contacts/import-files/display-success-import/display-success-import.component';
import { UnsubscribedContactsComponent } from '../contacts/contact-list/contact-list-contacts/unsubscribed-contacts/unsubscribed-contacts.component';
import { CompanyComponent } from '../companies/company/company.component';
import { UserComponent } from '../admin/user/user.component';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { NotFoundComponent } from '../auth/not-found/not-found.component';
import { UnauthorizedComponent } from '../auth/unauthorized/unauthorized.component';
import { NoRolesComponent } from '../auth/no-roles/no-roles.component';
import { UnsubscriberComponent } from '../admin/unsubscriber/unsubscriber.component';
import { CampaignStatisticComponent } from '../campaigns/campaign-statistic/campaign-statistic.component';
import { CumulativeCampaignStatisticsComponent } from '../reports/cumulative-campaign-statistics/cumulative-campaign-statistics.component';


export const routes: Routes = [
  { path: '', component: ContactListComponent, pathMatch: 'full' },
  { path: 'contactlist', component: ContactListComponent },
  { path: 'contactlist/:id', component: ContactListContactsComponent },
  { path: 'customfield', component: CustomFieldComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'contact/search', component: ContactSearchComponent },
  { path: 'importfile', component: ImportFilesComponent },
  { path: 'campaign', component: CampaignComponent },
  { path: 'importresults', component: DisplaySuccessImportComponent },
  { path: 'unsubscribedcontacts/:id', component: UnsubscribedContactsComponent },
  { path: 'company', component: CompanyComponent },
  { path: 'users', component: UserComponent },
  { path: 'unsubscribers', component: UnsubscriberComponent },
  { path: 'userprofile', component: UserProfileComponent },
  { path: 'notfound', component: NotFoundComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'norole', component: NoRolesComponent },
  { path: 'campaign/statistic', component: CampaignStatisticComponent },
  { path: 'campaignstatistics', component: CumulativeCampaignStatisticsComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  declarations: [
    NavMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
    NavMenuComponent
  ]
})
export class NavModule {
}
